import styled, { css } from 'styled-components'
import { IconComponent, themeColor, themeFontFamily, UIDirection } from 'LibNeo'

export const CheckboxWrapper = styled.div<{ error: boolean; initialHeight?: boolean }>`
	min-height: 36px;
	font-family: ${themeFontFamily('SBSansInterface')};

	${({ initialHeight = false }) =>
		initialHeight &&
		css`
			min-height: initial;
		`}

	.ant-form-explain {
		position: absolute;
	}

	.ant-checkbox-wrapper {
		display: flex;

		.ant-checkbox {
			top: auto;
		}

		border: none;
	}

	.ant-checkbox + span {
		display: flex;
		align-items: center;
		padding: 0;
	}

	.ant-checkbox {
		.ant-checkbox-inner {
			width: 20px;
			height: 20px;
			border-radius: 4px;
			border: 1px solid ${themeColor('gray', 3)};
		}

		.ant-checkbox-input {
			&:focus + .ant-checkbox-inner,
			&:hover + .ant-checkbox-inner {
				border: 1px solid ${themeColor('emerald', 5)};
			}
		}
	}

	.ant-checkbox.ant-checkbox-disabled {
		.ant-checkbox-inner {
			border: none;
			background-color: ${themeColor('gray', 2)};
		}

		.ant-checkbox-input {
			cursor: not-allowed;

			&:focus + .ant-checkbox-inner,
			&:hover + .ant-checkbox-inner {
				border: none;
			}
		}
	}

	.ant-checkbox.ant-checkbox-checked {
		.ant-checkbox-inner {
			border: none;
			background-color: ${themeColor('emerald', 5)};

			&:after {
				top: 0;
				left: 0;
				content: '';
				background-image: url('/svg/angle-white.svg');
				background-position: center;
				background-repeat: no-repeat;
				border: none;
				transform: none;
				width: 100%;
				height: 100%;
			}
		}

		.ant-checkbox-input {
			&:focus + .ant-checkbox-inner,
			&:hover + .ant-checkbox-inner {
				background-color: ${themeColor('emerald', 7)};
			}
		}
	}

	.ant-checkbox.ant-checkbox-checked.ant-checkbox-disabled {
		.ant-checkbox-inner {
			background-color: ${themeColor('emerald', 2)};
		}

		.ant-checkbox-input {
			cursor: not-allowed;

			&:focus + .ant-checkbox-inner,
			&:hover + .ant-checkbox-inner {
				background-color: ${themeColor('emerald', 2)};
			}
		}
	}

	.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked {
		.ant-checkbox-inner {
			background-color: ${themeColor('white')};
			border: 1px solid ${themeColor('gray', 3)};

			&:after {
				top: 50%;
				left: 50%;
				width: 10px;
				height: 10px;
				border: 0;
				transform: translate(-50%, -50%) scale(1);
				opacity: 1;
				content: ' ';
				background-image: none;
				background-color: ${themeColor('emerald', 5)};
			}
		}

		.ant-checkbox-input {
			&:focus + .ant-checkbox-inner,
			&:hover + .ant-checkbox-inner {
				border: 1px solid ${themeColor('emerald', 7)};
				background-color: ${themeColor('white')};

				&:after {
					background-color: ${themeColor('emerald', 7)};
				}
			}
		}
	}

	.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked.ant-checkbox-disabled {
		.ant-checkbox-inner {
			&:after {
				background-color: ${themeColor('emerald', 3)};
			}
		}

		.ant-checkbox-input {
			cursor: not-allowed;
			background-color: ${themeColor('white')};

			&:focus + .ant-checkbox-inner,
			&:hover + .ant-checkbox-inner {
				&:after {
					background-color: ${themeColor('emerald', 3)};
				}
			}
		}
	}

	.ant-checkbox:hover::after,
	.ant-checkbox-wrapper:hover .ant-checkbox::after {
		visibility: hidden;
	}

	.ant-checkbox-indeterminate .ant-checkbox-inner::after {
		background-color: ${themeColor('white')};
	}

	${({ error }) =>
		error &&
		css`
			.ant-checkbox {
				.ant-checkbox-inner {
					border: 1px solid ${themeColor('pink', 5)};
				}

				.ant-checkbox-input {
					&:focus + .ant-checkbox-inner,
					&:hover + .ant-checkbox-inner {
						border: 1px solid ${themeColor('pink', 5)};
					}
				}
			}

			.ant-checkbox.ant-checkbox-checked {
				.ant-checkbox-inner {
					border: none;
					background-color: ${themeColor('pink', 5)};
				}

				.ant-checkbox-input {
					&:focus + .ant-checkbox-inner,
					&:hover + .ant-checkbox-inner {
						background-color: ${themeColor('pink', 5)};
					}
				}
			}

			.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked {
				.ant-checkbox-inner {
					background-color: ${themeColor('white')};
					border: 1px solid ${themeColor('pink', 5)};

					&:after {
						background-color: ${themeColor('pink', 5)};
					}
				}

				.ant-checkbox-input {
					&:focus + .ant-checkbox-inner,
					&:hover + .ant-checkbox-inner {
						border: 1px solid ${themeColor('pink', 5)};
						background-color: ${themeColor('white')};

						&:after {
							background-color: ${themeColor('pink', 5)};
						}
					}
				}
			}
		`}
`

export const CheckboxGroupWrapperStyled = styled.div<{ direction: UIDirection }>`
	.ant-checkbox-group {
		${CheckboxWrapper} {
			margin-top: 24px;
		}
	}

	.ant-checkbox-group {
		display: grid;
		flex-wrap: wrap;
		gap: 16px;
		width: 100%;

		${({ direction }) =>
			direction === UIDirection.HORIZONTAL &&
			css`
				grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
			`}
	}
`

export const CheckboxLabelWrapper = styled.div`
	color: ${themeColor('gray', 8)};
	font-size: 14px;
	font-family: ${themeFontFamily('SBSansText')};
	line-height: 20px;
	font-weight: 400;
	word-break: break-word;
	white-space: normal;
	margin: 0 0 0 8px;
	padding: 0;
`

export const CheckboxLabelIcon = styled(IconComponent)`
	line-height: 20px;

	svg {
		width: 14px;
		height: 14px;
		margin-top: 2px;
	}
`

export const CheckboxLabelDescription = styled.div`
	font-size: 12px;
	font-family: ${themeFontFamily('SBSansText')};
	line-height: 20px;
	font-weight: 400;
	word-break: break-word;
	color: ${themeColor('gray', 6)};
`
